module.exports = __webpack_public_path__ + "static/media/no-photo.ce5fc191.jpg";